import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import createStyles from '@material-ui/core/styles/createStyles';
import { CircularProgressbar } from 'react-circular-progressbar';

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {},
    path: {
      stroke: (props: { color: string | undefined }) => props.color || theme.palette.primary.main,
      strokeLinecap: 'butt',
      transition: 'stroke-dashoffset 0.5s ease 0s',
    },
    trail: {
      stroke: theme.palette.grey['300'],
    },
    text: {
      fill: theme.palette.grey['700'],
      fontSize: '16px',
      fontFamily: 'Open Sans, sans-serif',
    },
    background: {},
  }),
);
interface StyledProgressbarProps {
  percentage: number;
  text: string;
  color: string;
}

const StyledProgressbar: React.FC<StyledProgressbarProps> = ({ percentage, text, color }: StyledProgressbarProps) => {
  const classes = useStyles({ color });
  return <CircularProgressbar value={percentage} text={text} strokeWidth={7} classes={classes} />;
};

export default StyledProgressbar;
